import React from 'react';
import { FaWhatsapp } from 'react-icons/fa'; // You can also use your own image/icon
import { Link } from 'react-router-dom';

function Whatsapp_icon() {
  const whatsappNumber = "9460548809"; // Replace with your number

  return (
    <>
      <Link
        to={`https://wa.me/${whatsappNumber}`}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-float"
      >
        <FaWhatsapp size={30} />
      </Link>

      <style>{`
        .whatsapp-float {
          position: fixed;
          bottom: 100px;
          right: 10px;
          background-color: #25d366;
          color: white;
          border-radius: 50%;
          padding: 15px;
          z-index: 1000;
          box-shadow: 0 4px 10px rgba(0,0,0,0.2);
          transition: transform 0.3s ease;
        }

        .whatsapp-float:hover {
          transform: scale(1.1);
        }
      `}</style>
    </>
  );
}

export default Whatsapp_icon;
